import React from "react";
import { verificationActions } from "actions/verification.actions";
import { connect } from "react-redux";
import { FilledButton } from "@sainsburys-tech/luna-button";

import {
  Notification,
  NotificationStatuses,
} from "@jsainsburyplc/id-ui-common";

import PageFormat from "components/PageFormat";
import { FAILURE_MESSAGE } from "constants/messages";

class EmailChangeVerification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
      hasExpired: undefined,
      token: this.props.match.params.token,
    };
  }

  handleVerificationClick = () => {
    const { dispatch } = this.props;
    this.setState({
      buttonDisabled: true,
    });
    dispatch(verificationActions.verifyEmailChange(this.state.token));
  };

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.expired !== undefined) {
      if (nextProps.expired === true) {
        this.setState({
          hasExpired: nextProps.expired,
          success: false,
          buttonDisabled: true,
        });
      }
    }

    if (nextProps.success !== undefined) {
      if (nextProps.success === true) {
        this.setState({
          success: nextProps.success,
          hasExpired: false,
          buttonDisabled: true,
        });
      }
    }
  }

  render() {
    return (
      <PageFormat>
        <div className="c-hero c-hero--center">
          <h3>You need to verify your email</h3>
        </div>
        <div className="ln-u-soft ln-u-text-align-center">
          <Notification>
            Your new email needs to be verified in order to login.
            <br />
            To do this, please click on the link below.
          </Notification>
          <br />
          <FilledButton
            id="submit"
            type="submit"
            disabled={this.state.buttonDisabled}
            onClick={this.handleVerificationClick}
            fullWidth
          >
            Verify your account
          </FilledButton>
          {this.state.success || this.state.hasExpired ? (
            <div>
              <div className="ln-c-card ln-c-card--soft">
                {this.state.success ? (
                  <Notification type={NotificationStatuses.SUCCESS_TYPE}>
                    You have successfully verified your email address.
                    <br />
                    For security reasons, a confirmation link has been sent to
                    your original email address. Please click on the link to
                    complete the process.
                  </Notification>
                ) : this.state.hasExpired ? (
                  <Notification type={NotificationStatuses.ERROR_TYPE}>
                    {FAILURE_MESSAGE}
                    <br />
                    The verification link is either invalid or has expired.
                    <br />
                    Please try again or contact the help desk.
                  </Notification>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      </PageFormat>
    );
  }
}

function mapStateToProps(state) {
  const { success, expired } = state.verification;
  return {
    success,
    expired,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    verification: (token) =>
      dispatch(verificationActions.verifyEmailChange(token)),
    dispatch,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailChangeVerification);
